var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5654 9.2139C16.9507 8.86522 17.5756 8.86522 17.961 9.2139C18.3463 9.56258 18.3463 10.1279 17.961 10.4766L12.6978 15.2385C12.3124 15.5872 11.6876 15.5872 11.3022 15.2385L6.03904 10.4766C5.65365 10.1279 5.65365 9.56258 6.03904 9.2139C6.42443 8.86522 7.04926 8.86522 7.43465 9.2139L11.0131 12.4516V3.53571C11.0131 3.23985 11.455 3 12 3C12.545 3 12.9868 3.23985 12.9868 3.53571V12.4516L16.5654 9.2139ZM3.25 19.25H20.75C21.4404 19.25 22 19.7475 22 20.3611C22 20.9748 21.4404 21.4722 20.75 21.4722H3.25C2.55964 21.4722 2 20.9748 2 20.3611C2 19.7475 2.55964 19.25 3.25 19.25Z",
    fill: "#A614B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon-download.b1df7c256bf4671184fb9689f74bb2c9.svg";
export { ForwardRef as ReactComponent };